export default __webpack_public_path__ + "images/5fa00dafb20874ccd2fc0e86dff3d119.svg";